import * as ChartPage from "./ChartPage";

export default [
	{ route: "/", page: ChartPage},
	{ route: "/chart", page: ChartPage},
];



/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/index.js
 **/